import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  ButtonToolbar,
  ButtonGroup,
  Button,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  Input,
  Alert,
  Label,
} from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import backgroundImg1 from "../../../../../assets/images/login/backgroundImg1.jpg";
import backgroundImg2 from "../../../../../assets/images/login/backgroundImg2.jpg";
import backgroundImg3 from "../../../../../assets/images/login/backgroundImg3.jpg";
import backgroundImg4 from "../../../../../assets/images/login/backgroundImg4.jpg";
import B1 from "../../../../../assets/images/login/B1.png";
import B2 from "../../../../../assets/images/login/B2.png";
import B3 from "../../../../../assets/images/login/B3.png";
import B4 from "../../../../../assets/images/login/B4.png";
import loginBlock from "../../../../../assets/images/login/loginBlock.jpg";
import LoginBlock from "../../../../../assets/images/login/LoginBlock.png";
import TLogo from "../../../../../assets/images/login/TLogo.svg";
import TransportLogo from "../../../../../assets/images/login/TransportLogo.svg";
import forgotPassword from "../../../../../assets/images/login/forgotPassword.svg";
import "./Login.scss";
import OTPInputs from "../OTPInputs/OTPInputs";
import LoginForm from "../LoginForm/LoginForm";
const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [keepLoggedIn, setKeepLoggedIn] = useState(false);
  const [backgroundIndex, setBackgroundIndex] = useState(0);
  const backgrounds = [
    // backgroundImg1,
    // backgroundImg2,
    // backgroundImg3,
    // backgroundImg4,
    // Add more image URLs as needed
    B1,
    B2,
    B3,
    B4,
  ];
  const [showOTP, setShowOTP] = useState(false);
  useEffect(() => {
    // Shuffle the images when the component mounts
    shuffleImages();
  }, []);

  // const shuffleImages = () => {
  //   const newIndex = Math.floor(Math.random() * backgrounds.length);
  //   setBackgroundIndex(newIndex);
  // };
  let lastRandomIndex = -1;
  const shuffleImages = () => {
    let newIndex = lastRandomIndex;

    while (newIndex === lastRandomIndex) {
      newIndex = Math.floor(Math.random() * backgrounds.length);
    }

    lastRandomIndex = newIndex; // Update the last index reference
    setBackgroundIndex(newIndex);
  };
  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const handleKeepLoggedInChange = (e) => {
    setKeepLoggedIn(e.target.checked); // Update the state when the checkbox changes
  };
  const handleForgotPassword = () => {
    // Implement your logic for handling "Forgot Password" functionality here
    console.log("Forgot password clicked!");
    // Example: Redirect to a "Forgot Password" page or display a modal
  };
  const handleLogin = (e) => {
    // e.preventDefault();
    // Add your login logic here (e.g., sending login data to a server)
    // For demo purposes, simply logging the entered credentials
    console.log("Username:", username);
    console.log("Password:", password);
    // You can clear the input fields after submission if needed
    // setUsername("");
    // setPassword("");
    // Show OTP section upon successful login (dummy logic for demonstration)
    setShowOTP(true);
  };
  const handleResendCode = () => {
    // Implement your logic to resend the code here
    console.log("Resending code...");
    // You can add code here to trigger a resend action
  };
  const handleNoAccess = () => {
    // Implement what happens when the user doesn't have access to their phone
    console.log("Don't have access to your phone?");
    // You can add functionality or display a message here
  };
  return (
    <React.Fragment>
      <div
        className="container"
        style={{
          backgroundImage: `url(${backgrounds[backgroundIndex]})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          height: "100%",
          margin: "0",
          padding: "0",
        }}
      >
        <Container fluid className="p-0">
          <Row xl={12} md={12} sm={6} xs={6}>
            <Col xl={12} md={12} sm={6} xs={6}>
              <div className="login-page">
                <div className="header">
                  <img src={TLogo} />
                  <img src={TransportLogo} style={{ margin: "10px" }} />
                </div>
                <div className="loginBlock">
                  {/* <div className="loginBlockImage"> */}
                  <img
                    src={loginBlock}
                    //src={LoginBlock}
                    alt="Login Block"
                    className="loginBlockOverlay"
                  />
                  {/* </div> */}
                  <div className="loginForm">
                    <div className="login-header">
                      <img src={TLogo} className="tLogo" />
                      <img
                        src={TransportLogo}
                        className="transportLogo"
                        //style={{ margin: "10px" }}
                      />
                    </div>
                    {showOTP ? (
                      <>
                        <OTPInputs
                          // handleResendCode={handleResendCode}
                          // handleNoAccess={handleNoAccess}
                          expectedOTP={"111111"}
                        />
                      </>
                    ) : (
                      <LoginForm
                        username={username}
                        password={password}
                        keepLoggedIn={keepLoggedIn}
                        handleUsernameChange={handleUsernameChange}
                        handlePasswordChange={handlePasswordChange}
                        handleKeepLoggedInChange={handleKeepLoggedInChange}
                        handleForgotPassword={handleForgotPassword}
                        handleLogin={handleLogin}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Login;
